import { render, staticRenderFns } from "./RespondidasSelo.vue?vue&type=template&id=7d07d1bc&scoped=true"
import script from "./RespondidasSelo.vue?vue&type=script&lang=js"
export * from "./RespondidasSelo.vue?vue&type=script&lang=js"
import style0 from "./RespondidasSelo.vue?vue&type=style&index=0&id=7d07d1bc&prod&lang=css"
import style1 from "./RespondidasSelo.vue?vue&type=style&index=1&id=7d07d1bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d07d1bc",
  null
  
)

export default component.exports